import type { RequestedDocument } from "../../document";
import type { ChecklistGroup, ChecklistItem } from "./checklist";
import { requestedDocumentRequirement } from "./document-requirements";
import type { RequirementProgress } from "./progress";
import type { ChecklistRequirement } from "./requirement-policy";

export interface RequirementEvaluationInput {
  /** The configured items that apply to the chosen resolution. */
  checklist?: readonly ChecklistItem[];
  groups?: readonly ChecklistGroup[];
  /** task.requestedDocuments; each entry contributes one row. */
  requestedDocuments?: readonly RequestedDocument[];
  /** task.requirementProgress. */
  progress?: RequirementProgress | null;
}

/** The configured items followed by the documents this task asked for. */
export const effectiveRequirements = (
  input: RequirementEvaluationInput,
): ChecklistRequirement[] => [
  ...(input.checklist ?? []).map(
    ({ id, resolutionIds: _resolutionIds, ...item }): ChecklistRequirement => ({
      ...item,
      key: id,
      kind: "checklist_item",
    }),
  ),
  ...(input.requestedDocuments ?? []).map(requestedDocumentRequirement),
];
